import {QueryClient} from "@tanstack/react-query";

/**
 * One cache for the whole app.
 *
 * Router loaders need it too: they run outside React, before any provider
 * mounts, and what a loader fetches must already be warm when the component
 * that needs the same data renders. Two clients would mean two fetches and
 * two answers that can disagree.
 */
export const queryClient = new QueryClient();
